






import Vue from 'vue';
import CheckInfo from '@/components/CheckInfo.vue';
Vue.component('CheckInfo-component', CheckInfo);

export default Vue.extend({
  name: 'myCheckInfo',
  data() {
    return {
    };
  },
  computed: {

  },
  methods: {
  },
  destroyed() {
    // this.$store.dispatch('setCheckResult', []);
  }
});
